"use client";

import { useEffect } from "react";
import { useWebInfoStore } from "context/webInfoStore";

const WebInfoProvider = ({
  initialWebInfo = null,
  initialMenus = null,
  children,
}) => {
  const setInitialData = useWebInfoStore((state) => state.setInitialData);
  const fetchAll = useWebInfoStore((state) => state.fetchAll);

  useEffect(() => {
    setInitialData({ webInfo: initialWebInfo, menus: initialMenus });
  }, [initialWebInfo, initialMenus, setInitialData]);

  useEffect(() => {
    const hasInitial =
      Boolean(initialWebInfo) ||
      (Array.isArray(initialMenus) && initialMenus.length > 0);
    if (!hasInitial) {
      fetchAll();
    }
  }, [fetchAll, initialWebInfo, initialMenus]);

  return children;
};

export default WebInfoProvider;
